export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loader-urbania.3662e1fc.gif";